import { NgModule } from '@angular/core';

import { PeiluyotRouting } from './peiluyots.routes';
import { SharedModule } from '../shared/shared.module';

import { CustomerHamtanaFilter } from '../shared/pipes/custom-hamtana-filter.pipe';
import { CustomerPeilutFilter } from '../shared/pipes/custom-peilut-filter.pipe';
import { CustomerTatPeilutDdlFilter } from '../shared/pipes/custom-tat-peilutddl-filter.pipe';

import { HomeComponent } from './home/home.component'
import { PeilutComponent } from './peilut.component'
import { EndRishumComponent } from './endRishum/end-rishum.component'
import { ReportComponent } from '../reports/peilut-reports/report.component';
import { EndTkufatRishumComponent } from "./end-tkufat-rishum/end-tkufat-rishum.component";
import { MyDatePickerModule } from 'mydatepicker';

@NgModule({
    imports: [PeiluyotRouting, SharedModule, MyDatePickerModule],
    declarations: [
        HomeComponent,
        PeilutComponent,
        EndRishumComponent,
        ReportComponent,
        EndTkufatRishumComponent,

        CustomerHamtanaFilter,
        CustomerPeilutFilter,
        CustomerTatPeilutDdlFilter
    ],
})

export class PeiluyotModule { }
